import Select, { SingleValue } from 'react-select';
import { BaseSelector } from '../../../../models/baseSelector';

interface Props {
    name: string;
    options: BaseSelector[];
    onChange: (name: string, value: string) => void;
    value: string | null | number;
    required: boolean;
    hideLabel?: boolean;
}

export const RequestStatusSelector = ({
    name,
    onChange,
    value,
    options,
    required,
    hideLabel = false,
}: Props) => {
    const handleChange = (newValue: SingleValue<BaseSelector>) => {
        if (newValue && newValue.value) onChange(name, newValue.value.toString());
    };

    return (
        <div className='mb-2'>
            {!hideLabel ? (
                <label htmlFor={name} key={`label-${name}`} className='form-label '>
                    Estado
                    {required && <span className='text-danger'>*</span>}
                </label>
            ) : null}

            <Select
                id={name}
                key={name}
                name={name}
                isSearchable={true}
                required={required}
                onChange={handleChange}
                options={options}
                placeholder={hideLabel ? 'Estado' : '- Seleccione -'}
                className='text-dark '
                value={
                    options.find((a) => a.value === value) ?? {
                        label: `Seleccionar...`,
                        value: 0,
                    }
                }
            />
        </div>
    );
};
